import {BusinessOrderStartError} from './business-order-start-error';
import {BusinessOrderStartErrorFetchLinks} from './business-order-start-error-fetch-links';
import {BusinessOrderStartErrorFetch} from './business-order-start-error-fetches.model';

interface Props {
  errors: string[];
  errorFetches: BusinessOrderStartErrorFetch[];
  canViewWorkflow: boolean;
}

export function BusinessOrderStartErrors(props: Props) {
  if (props.errors.length === 0) {
    return null;
  }

  return <div className="text-storz-red bg-storz-red-background border border-solid border-storz-red-border">
    <div>
      <strong>Achtung: BA konnte nicht gestartet werden.</strong>
    </div>
    {props.errors.map((error, index) =>
      <BusinessOrderStartError key={index} error={error}/>,
    )}
    {props.canViewWorkflow &&
      <BusinessOrderStartErrorFetchLinks errorFetches={props.errorFetches}/>
    }
  </div>;
}
